import React from 'react';
import Typography from '@mui/material/Typography';
interface AlertBoxTitleProps {
  children: React.ReactNode;
  disableMarginTop?: boolean;
}
export const AlertBoxTitle: React.FC<AlertBoxTitleProps> = ({ children, disableMarginTop = false }) => {
  return (
    <Typography
      variant="body1"
      sx={{
        fontWeight: 600,
        fontSize: '14px',
        color: '#344054',
        lineHeight: '20px',
        mt: disableMarginTop ? '0' : '10px',
      }}
    >
      {children}
    </Typography>
  );
};
